import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import ErrorMessage from "./ErrorMessage";
import ErrorMessage1xbet from "./ErrorMessage1xbet";

function ErrorMessageIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? (
    <ErrorMessage1xbet {...props} />
  ) : (
    <ErrorMessage {...props} />
  );
}

export default ErrorMessageIndex;
